<template>
  <div v-if="accountCompliance" class="w-full mb-3">

    <!-- Pasos -->
    <div
      class="bg-white rounded-lg shadow p-4 border border-gray-200 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div class="flex flex-wrap lg:flex-nowrap items-center gap-4 lg:gap-6">
        <div v-for="step in steps" :key="step.key" class="flex items-center gap-1 cursor-pointer group"
          @click="!step.completed && step.action()">
          <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors duration-300"
            :class="step.completed
              ? 'border-blue-500 bg-blue-500'
              : 'border-gray-300 bg-white group-hover:border-blue-400'">
            <svg v-if="step.completed" class="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="3">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <span class="text-xs font-medium text-center leading-tight transition-colors duration-300" :class="step.completed
            ? 'text-gray-400 line-through'
            : 'text-blue-500 group-hover:text-blue-600'">
            {{ step.label }}
          </span>
        </div>
      </div>
    </div>

    <!-- Barra de progreso -->
    <div class="flex items-center gap-3 mt-2 px-1">
      <span class="text-xs text-gray-500">{{ completedCount }}/{{ totalSteps }}</span>
      <div class="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
        <div class="h-full bg-blue-400 rounded-full transition-all duration-500"
          :style="{ width: progressPercent + '%' }" />
      </div>
      <span class="text-xs text-gray-500">{{ progressPercent }}%</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AccountComplianceProgress',
  computed: {
    accountCompliance() {
      return this.$store.state.account.accountCompliance;
    },
    steps() {
      const c = this.accountCompliance || {};
      return [
        {
          key: 'practiceOrder',
          label: 'Crear orden\nde práctica',
          completed: !!c.practiceOrderCompletedAt,
          action: () => this.$router.push({ name: 'orders.create', query: { isTest: true } }),
        },
        {
          key: 'businessConfigured',
          label: 'Configurar\nmi negocio',
          completed: !!c.businessConfiguredAt,
          action: () => this.$router.push({ name: 'administration.business' }),
        },
        {
          key: 'firstRealOrder',
          label: 'Crear mi\nprimera orden real',
          completed: !!c.firstRealOrderCompletedAt,
          action: () => this.$router.push({ name: 'orders.create' }),
        },
        {
          key: 'firstProduct',
          label: 'Agregar mi\nprimer producto',
          completed: !!c.firstProductAddedAt,
          action: () => this.$router.push({ name: 'products.create' }),
        },
        {
          key: 'reports',
          label: 'Revisar mis\nganancias',
          completed: !!c.reportsVisitedAt,
          action: () => this.$router.push({ name: 'finances.index' }),
        },
      ];
    },
    completedCount() {
      return this.steps.filter(s => s.completed).length;
    },
    totalSteps() {
      return this.steps.length;
    },
    progressPercent() {
      return Math.round((this.completedCount / this.totalSteps) * 100);
    },
  },
};
</script>